module.exports = __webpack_public_path__ + "static/img/place_8.d0cbaeec.png";